import { c as _c } from "react-compiler-runtime";
import React, { Fragment } from 'react';
import { string } from 'prop-types';
import formatDates from '@nike/shop-apis/utils/date/format-dates';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';

/**
 * @private
 * @memberof nr-omni-shipping-pickup
 * @description Renders appropriate arrival date messaging with local specific date formatting.  If given minShipDate, render date range
 *
 * @param {object} props - react component props
 * @param {string} props.minShipDate - earliest arrival date
 * @param {string} props.maxShipDate - latest arrival date
 * @param {string} props.timeZone - timezone of latest arrival date
 * @returns {React.Component} - react component
 */
var ArrivesDate = function ArrivesDate(t0) {
  var $ = _c(13);
  var minShipDate = t0.minShipDate,
    maxShipDate = t0.maxShipDate,
    timeZone = t0.timeZone;
  var t1;
  if ($[0] !== maxShipDate || $[1] !== minShipDate || $[2] !== timeZone) {
    t1 = formatDates({
      timeZone: timeZone,
      minDate: minShipDate,
      maxDate: maxShipDate
    });
    $[0] = maxShipDate;
    $[1] = minShipDate;
    $[2] = timeZone;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  var _t = t1,
    formattedMinDate = _t.formattedMinDate,
    formattedMaxDate = _t.formattedMaxDate;
  var t2;
  if ($[4] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "arrivesMessage",
      primaryValue: "Arrives",
      description: "Indicates the product will arrive at a certain date range (minimum and maximum arrival dates given), Example: '>Arrives< Thu, Oct 24 - Thu, Oct 25'"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  var arrivesMessage = useI18nString(t2);
  var t3;
  if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = {
      stringKey: "arrivesByMessage",
      primaryValue: "Arrives by",
      description: "Indicates the product will arrive no later than this time (no minimum date given, only max arrival date), Example: '>Arrives by< Thu, Oct 24'"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  var arrivesByMessage = useI18nString(t3);
  if (minShipDate && formattedMinDate !== formattedMaxDate) {
    var _t2;
    if ($[6] !== arrivesMessage || $[7] !== formattedMaxDate || $[8] !== formattedMinDate) {
      _t2 = /*#__PURE__*/React.createElement(React.Fragment, null, arrivesMessage, "\xA0", formattedMinDate, " - ", formattedMaxDate);
      $[6] = arrivesMessage;
      $[7] = formattedMaxDate;
      $[8] = formattedMinDate;
      $[9] = _t2;
    } else {
      _t2 = $[9];
    }
    return _t2;
  }
  var t4;
  if ($[10] !== arrivesByMessage || $[11] !== formattedMaxDate) {
    t4 = /*#__PURE__*/React.createElement(React.Fragment, null, arrivesByMessage, "\xA0", formattedMaxDate);
    $[10] = arrivesByMessage;
    $[11] = formattedMaxDate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
ArrivesDate.propTypes = {
  minShipDate: string,
  maxShipDate: string,
  timeZone: string
};
export default ArrivesDate;